import React from "react";

const ContactMeanFake = () => {
  <>
    <div className="contact-mean-fake">
      <div className="skeleton contact-mean-fake--title" />
      <div className="contact-mean-fake--input">
        <div className="skeleton contact-mean-fake--title" />
      </div>
      <div className="skeleton contact-mean-fake--btn" />
    </div>
    <style jsx>{`
      .contact-mean-fake {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        &--title {
          height: 16px;
          width: 90%;
        }
        &--input {
          height: 24px;
          width: 50%;
          border: 1px solid #dddddd;
          border-radius: 4px;
        }
        &--btn {
          height: 25px;
          width: 25%;
        }
      }
      @media screen and (min-width: 1024px) {
        .contact-mean-fake {
          width: 60%;
        }
      }
    `}</style>
  </>;
};

export default ContactMeanFake;
